import React from 'react';
import { Box } from '@mui/material';

const CARD_SHADOW =
  '0px 1px 2px 0px rgba(162, 172, 177, 0.2), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)';

const richTextStyles = {
  '& p': {
    margin: 0,
  },
  '& p + p': {
    marginTop: '1.5rem',
  },
  '& a': {
    color: '#162F3B',
  },
  '& strong': {
    fontWeight: 700,
  },
};

const GenericTextBlockComponent = ({ data }) => {
  const { title = '', description = '' } = data || {};

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1100px',
          backgroundColor: '#FFFFFF',
          borderRadius: '32px',
          boxShadow: CARD_SHADOW,
          px: '48px',
          py: '32px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          component="div"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '3rem',
            lineHeight: '3.25rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            mb: '20px',
            ...richTextStyles,
          }}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Box
          component="div"
          sx={{
            maxWidth: '910px',
            mx: 'auto',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1.5rem',
            lineHeight: '1.75rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            ...richTextStyles,
          }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Box>
    </Box>
  );
};

export default GenericTextBlockComponent;
